// ANGEL FLIGHT — M3: The Treeline (the campaign's third sortie).
//
// A fog-choked dead forest under sickly-green overcast — the built-but-unused
// `dead-forest` biome finally gets a mission. The longest, hardest hold yet:
// every threat the roster has funnels up one choked corridor — shambling filler,
// rushing runners, acid spitters, RPG screamers, the street RIFLEMEN (marauders)
// chipping from the brush, and brute walls. Friendlies are still pushing through
// it, so target discipline matters more than ever — CHECK YOUR FIRE.
//
// Pure data. theme 'dead-forest' drives the murky-green palette (config/render.ts
// themes); the ColorWorld reads it. objective 'survive' (the 'boss' objective kind
// stays reserved for a later capstone).

import type { MissionDef } from '../core/types';

export const treeline: MissionDef = {
  id: 'm3-the-treeline',
  name: 'The Treeline',
  biome: 'Dead Forest — Overcast',
  objective: 'survive',
  theme: 'dead-forest',
  durationMs: 120_000,
  brief:
    'Last corridor out of the valley. The treeline is crawling — riflemen in the brush, RPGs in the murk, and the dead behind them. Friendlies are still moving through it. Hold until exfil — and CHECK YOUR FIRE.',
  waves: [
    { atMs: 1_500, spawns: { shambler: 5, runner: 2 }, banner: 'INTO THE TREELINE' },
    { atMs: 11_000, spawns: { runner: 5, marauder: 2, trooper: 1 }, banner: 'RIFLEMEN IN THE BRUSH' },
    { atMs: 23_000, spawns: { shambler: 6, spitter: 2, runner: 3 }, banner: 'SPITTERS' },
    { atMs: 35_000, spawns: { runner: 6, marauder: 3, screamer: 1, trooper: 1 } },
    { atMs: 48_000, spawns: { shambler: 7, runner: 4, brute: 1 }, banner: 'BRUTE' },
    { atMs: 62_000, spawns: { screamer: 2, marauder: 3, spitter: 2, trooper: 2 }, banner: 'CROSSFIRE' },
    { atMs: 77_000, spawns: { runner: 8, shambler: 6, marauder: 2, brute: 1 } },
    { atMs: 92_000, spawns: { screamer: 3, marauder: 4, runner: 6, trooper: 2 }, banner: 'THEY HAVE THE RANGE' },
    { atMs: 107_000, spawns: { runner: 10, shambler: 8, brute: 2, screamer: 2, marauder: 3 }, banner: 'LAST STAND' },
  ],
};
